// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__KevyV","h3":"styles_h3__Fwm_O","h1":"styles_h1__fhvKn"};